<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addNewShiponlyModal"
        persistent
        max-width="900px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">New order</span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeAddNewShiponlyModal(), $validator.reset()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                Item ordered successfully
              </v-alert>
              <v-alert
                type="error"
                :value="checkURL"
              >
                URL format not acceptable
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex xs12>
                  <branch-select v-model="makeOrderData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="loggedInUserData.is_staff"
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    item-value="value"
                    v-model="makeOrderData.customer_id_fk"
                    :error-messages="errors.collect('customer_id_fk')"
                    data-vv-name="customer_id_fk"
                    label="Customer*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Quantity*"
                    v-model="makeOrderData.quantity"
                    :error-messages="errors.collect('quantity')"
                    v-validate="'required|numeric|min_value:1'"
                    data-vv-name="quantity"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="warehouses"
                    item-value="value"
                    v-model="makeOrderData.warehouse_id_fk"
                    :error-messages="errors.collect('warehouse_id_fk')"
                    data-vv-name="warehouse_id_fk"
                    label="Warehouse*"
                    v-validate="'required'"
                    @input="handleSelectWarehouse(makeOrderData.warehouse_id_fk)"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="transportationTypes"
                    item-value="id"
                    item-text="name"
                    v-model="makeOrderData.transportation_type"
                    :error-messages="errors.collect('Transportation Type')"
                    data-vv-name="Transportation Type"
                    label="Transportation Type*"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>


                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Weight"
                    v-model="makeOrderData.item_weight"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Volume"
                    v-model="makeOrderData.volume"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Track number"
                    v-model="makeOrderData.track_number"
                    data-vv-name="track_number"
                    @input="removeSpaces()"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Coupon"
                    v-model="makeOrderData.coupon"
                    data-vv-name="coupon"
                  ></v-text-field>
                  <span
                    v-if="notCouponCode"
                    style="color: red"
                  >This field must contain a Coupon Code</span>
                </v-flex>
                <order-images
                    v-if="makeOrderData.order_id"
                    :formData="makeOrderData"
                  />
              </v-layout>
              <!--<div>-->
              <!--<h5 class="lead">-->
              <!--</h5>  -->
              <!--</div>-->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeAddNewShiponlyModal(), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >Add</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
  <!-- c_o_d -->
</template>
<script>
import { Validator } from 'vee-validate'

Validator.extend('max_file_size', {
  getMessage: (field, params) => `The ${field} must not exceed ${params[0]} MB.`,
  params: ['size'],
  validate(value, args) {
    if (!value || !value.length) return true // No file selected
    const file = value[0]
    const size = parseFloat(args[0]) // Convert parameter to number
    if (!file || !file.size) return false
    return file.size <= size * 1024 * 1024 // Convert MB to bytes
  }
})

export default {
  created() {
    this.getLoggedInUser()
  },

  props: [
    'addNewShiponlyModal',
    'warehouses',
    'closeAddNewShiponlyModal',
    'checkAlert',
    'deliveryTypes',
    'makeOrderData',
    'makeNewOrder',
    'customers',
    'checkURL',
    'loading'
  ],

  data() {
    return {
      loggedInUserData: {},
      notCouponCode: false,
      transportationTypes: [],
      imagePreview: null
    }
  },

  methods: {
    handleSelectWarehouse(id) {
      this.makeOrderData.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleFileUpload(event) {
      this.makeOrderData.image = null
      this.makeOrderData.fileName = ''
      this.$validator.errors.remove('file')
      const file = event.target.files[0]
      if (file && !this.errors.has('file')) {
        this.file = file
        this.makeOrderData.image = file
        this.makeOrderData.fileName = file.name
        this.imagePreview = URL.createObjectURL(file)
      } else {
        this.file = null
        this.makeOrderData.image = null
        this.imagePreview = null
      }
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.makeOrderData.coupon && this.makeOrderData.coupon.length) {
            if (this.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              this.notCouponCode = false
              this.makeNewOrder()
            } else {
              this.notCouponCode = true
            }
          } else {
            this.notCouponCode = false
            this.makeNewOrder()
          }
        }
      })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addNewShiponly.vue